<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.name"
          placeholder="权限名称"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" @click="$router.push('add-permission')">添加权限</Button>
    </div>
    <div class="filter">
      <div class="filter-item">
        <span class="title">状态</span>
        <Select style="width: 200px" placeholder="请选择状态" v-model="search.status">
          <Option label="全部" value=""></Option>
          <Option label="有效" value="1"></Option>
          <Option label="无效" value="0"></Option>
        </Select>
      </div>
      <div class="filter-item">
        <Button style="margin-left: 10px; width: 90px" type="primary" icon="ios-search" @click="searchFn">筛选</Button>
        <Button style="margin-left: 10px; width: 90px" @click="clearFn">清空</Button>
      </div>
    </div>
    <div class="table">
      <Table row-key="id" border :columns="diyData.columns" :data="apiData.tableList"></Table>
    </div>
  </div>
</template>
<script>
  import { apiPermissionList, apiPermissionDelete } from '@/api/permission/permission'
  export default {
    name: 'permission-list',
    data() {
      return {
        query: {},
        search: {
          name: '',
          status: '',
          page: 1,
        },
        diyDom: {},
        diyData: {
          columns: [
            {
              title: 'ID',
              width: 90,
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              title: '权限名称',
              key: 'name',
              render: (h, params) => {
                if (params.row.grade != '0') {
                  return h('div', [
                    h(
                      'span',
                      {
                        style: {
                          marginLeft: `${params.row.grade * 20}px`,
                        },
                      },
                      '|— ' + params.row.name
                    ),
                  ])
                } else {
                  return h('div', [h('span', {}, params.row.name)])
                }
              },
            },
            {
              title: '路由',
              key: 'menu_url',
            },
            {
              title: '标识',
              key: 'mark',
            },
            {
              title: '接口路径',
              key: 'http_path',
            },
            {
              title: '排序',
              width: 90,
              key: 'sort',
            },
            {
              title: '状态',
              key: 'status_lab',
              width: 90,
            },
            {
              title: '操作',
              fixed: 'right',
              width: 120,
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: 'add-permission',
                            query: {
                              id: params.row.id,
                            },
                          })
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: 'red',
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '请确认是否删除当前权限？',
                            onOk: () => {
                              apiPermissionDelete(params.row.id).then(res => {
                                this.$Message.success('删除成功')
                                this.getTableList()
                              })
                            },
                          })
                        },
                      },
                    },
                    '删除'
                  ),
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          tableList: [],
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiPermissionList({
          ...this.search,
        })
          .then(res => {
            this.apiData.tableList = this.iteratorMenu(res.data)
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 迭代菜单
      iteratorMenu(menu, grade = 0, target = []) {
        menu.forEach(item => {
          if (item.children) {
            item.grade = grade
            target.push(item)
            this.iteratorMenu(item.children, grade + 1, target)
          } else {
            item.grade = grade
            target.push(item)
          }
        })
        return target
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      clearFn() {
        this.search = {
          name: '',
          status: '',
          page: 1,
        }
        this.getTableList()
      },
    },
    mounted() {
      this.getTableList()
    },
  }
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
